import React, { useState, useEffect } from "react";
import { TextField, MenuItem } from "@mui/material";
import { MdGTranslate } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addMandal, fetchMandals, updateMandal } from "../../redux/district/districtSlice";
import { LoadingButton } from "@mui/lab";
import MandalsTable from "./MandalsTable";

const states = ["Andhra Pradesh", "Telangana"];

function AddMandal() {
  const dispatch = useDispatch();
  const { data, mandals } = useSelector((state) => state.districts);

  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [mandal, setMandal] = useState("");
  const [mandalInTelugu, setMandalInTelugu] = useState("");
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    if (editId) {
      const existingMandal = mandals.find((item) => item._id === editId);
      if (existingMandal) {
        setState(existingMandal.state.english);
        setDistrict(existingMandal.districts.english);
        setMandal(existingMandal.mandal.english);
        setMandalInTelugu(existingMandal.mandal.telugu);
      }
    }
  }, [editId, mandals]);

  // Translation function
  const translateText = async (text) => {
    if (!text) return "";
    const isTelugu = /[\u0C00-\u0C7F]/.test(text);
    const sourceLang = isTelugu ? "te" : "en";
    const targetLang = isTelugu ? "en" : "te";

    const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${encodeURIComponent(
      text
    )}`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      return data[0][0][0] || text;
    } catch (error) {
      console.error("Translation error", error);
      return text;
    }
  };

  const handleMandalChange = (e) => {
    setMandal(e.target.value);
  };

  const handleTranslateClick = async () => {
    const translatedText = await translateText(mandal);
    setMandalInTelugu(translatedText);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (state && district && mandal) {
      const formData = {
        state: {
          english: state,
          telugu: state === "Telangana" ? "తెలంగాణ" : "ఆంధ్ర ప్రదేశ్",
        },
        districts: {
          english: district,
          telugu: data[0][state]?.find((d) => d.english === district)?.telugu || district,
        },
        mandal: {
          english: mandal[0].toUpperCase() + mandal.slice(1),
          telugu: mandalInTelugu,
        },
      };
      if (editId) {
        dispatch(updateMandal({ id: editId, mandalData: formData }));
        toast.success("Mandal updated successfully!");
      } else {
        dispatch(addMandal(formData));
        toast.success("Mandal added successfully!");
      }

      // Reset form fields
      setMandalInTelugu("");
      setState("");
      setDistrict("");
      setMandal("");
    } else {
      toast.warn("Please fill all required fields correctly.");
    }
  };

  return (
    <div>
      <div className="main_fragnent_container p-2">
        <div className="profile_container_header">
          <div className="profile_co_header_left">
            <span>Add Mandal</span>
          </div>
        </div>
        <div className="main_recha_container">
          <div className="inputs_container">
            <div className="dn_input_box">
              <div className="translate_container">
                <button className="translate_btn" onClick={handleTranslateClick}>
                  <MdGTranslate className="translate_icon" />
                  <span className="translate_text">Click to Translate</span>
                </button>
              </div>
            </div>
            <div className="dn_input_box">
              <TextField
                id="select-state"
                label="Select State"
                select
                className="input_style"
                value={state}
                onChange={(e) => setState(e.target.value)}
                size="small"
              >
                {states.map((state) => (
                  <MenuItem key={state} value={state}>
                    {state === "Telangana" ? "Telangana ( తెలంగాణ )" : ""}
                    {state === "Andhra Pradesh" ? "Andhra Pradesh ( ఆంధ్ర ప్రదేశ్ )" : ""}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            {data[0] && (
              <div className="dn_input_box">
                <TextField
                  id="select-district"
                  label="Select District"
                  select
                  className="input_style"
                  value={district}
                  onChange={(e) => setDistrict(e.target.value)}
                  size="small"
                >
                  {data[0][state]?.map((district) => (
                    <MenuItem key={district.english} value={district.english}>
                      {district.english} ({district.telugu})
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            )}

            <div className="dn_input_box">
              <TextField
                label="Mandal (English)"
                variant="outlined"
                className="input_style"
                autoComplete="off"
                size="small"
                fullWidth
                value={mandal}
                onChange={handleMandalChange}
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="Mandal (Telugu)"
                variant="outlined"
                className="input_style"
                autoComplete="off"
                size="small"
                fullWidth
                value={mandalInTelugu}
                onChange={(e) => setMandalInTelugu(e.target.value)}
              />
            </div>

            <div className="button_container">
              <LoadingButton variant="contained" color="primary" onClick={handleSubmit}>
                {editId ? "Update Mandal" : "Add Mandal"}
              </LoadingButton>
            </div>
          </div>
        </div>
      <MandalsTable setEditId={setEditId} mandals={mandals}/>
      </div>
    </div>
    
  );
}

export default AddMandal;
